import React from 'react'
import { useStore } from 'stook'

interface ISearchQuery {
  keyword: string
  pageIndex: number
}

export default function useOrderSearchQuery() {
  const [orderSearchQuery, setOrderSearchQuery] = useStore<ISearchQuery>(
    'OrderSearchQuery',
    {
      pageIndex: 1,
      keyword: '',
    }
  )

  const updatePage = (page: number) => {
    setOrderSearchQuery((state) => {
      state.pageIndex = page
    })
  }

  const updateKeyword = (kw: string) => {
    setOrderSearchQuery((state) => {
      state.keyword = kw
    })
  }

  const resetOrderSearchQuery = () => {
    setOrderSearchQuery((state) => {
      state.pageIndex = 1
      state.keyword = ''
    })
  }

  return {
    orderSearchQuery,
    updatePage,
    updateKeyword,
    resetOrderSearchQuery
  }
}
